import { useEffect, useState } from "react";

import { User as AuthUser } from "firebase/auth";
import { api } from "../api/api";
import { appActions } from "../store/slices/appSlice";
import { auth } from "../firebaseConfig";
import { useAppDispatch } from "../store";

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const [authUser, setAuthUser] = useState<AuthUser | null>(null);
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      console.log("+ + + useAuth onAuthStateChanged", !!user);
      dispatch(appActions.setAuthUser(user?.toJSON()));
      setAuthUser(user);
      const idToken = await user?.getIdToken();
      const PARENT_ORIGIN = window.location.origin;

      if (idToken) {
        const customToken = await api.login.getCustomToken(idToken);
        console.log(
          "+ + + useAuth customToken",
          customToken?.slice(0, 10) + "...",
          PARENT_ORIGIN
        );
        window.top?.postMessage(
          {
            type: "LOA_AUTH_TOKEN",
            token: customToken,
          },
          PARENT_ORIGIN
        );
      }

      // dispatch(appActions.ready());
    });
    return () => unsubscribe();
  }, [dispatch]);

  return { authUser };
};
